/**
 * Plantilla por defecto para el quiz de Diagnóstico (escenario 2).
 * Una sola respuesta correcta. options: id, text, correct, explanation (HTML del contenido de la tarjeta), confirmExplanation (opcional).
 */
export const DEFAULT_SCENARIO2_OPTIONS = [
	{
		id: 1,
		text: "Diagnóstico 1",
		correct: false,
		explanation: `<div class="txt-turquoise"><div>Nefritis lúpica clase II</div><div>Índice de actividad: 8/24</div><div>Índice de cronicidad: 3/12</div></div>`,
		confirmExplanation: "",
	},
	{
		id: 2,
		text: "Diagnóstico 2",
		correct: false,
		explanation: `<div class="txt-turquoise"><div>Nefritis lúpica clase V</div><div>Índice de actividad: 15/24</div><div>Índice de cronicidad: 2/12</div></div>`,
		confirmExplanation: "",
	},
	{
		id: 3,
		text: "Diagnóstico 3",
		correct: true,
		explanation: `<div class="txt-turquoise"><div>Nefritis lúpica clase IV</div><div>Índice de actividad: 12/24</div><div>Índice de cronicidad: 1/12</div></div>`,
		confirmExplanation: "",
	},
	{
		id: 4,
		text: "Diagnóstico 4",
		correct: false,
		explanation: `<div class="txt-turquoise"><div>Nefritis lúpica clase III</div><div>Índice de actividad: 10/24</div><div>Índice de cronicidad: 6/12</div></div>`,
		confirmExplanation: "",
	},
];
